import { api } from '../../utils/api';

export const postBond = async (data) => {
  try {
    const response = await api.post("bond", data);
    return response.data
  } catch (e) {
    throw (e);
  }
}